module.exports = "/_next/static/images/forestryMob-3541f308a453ce03231b9f2300d3cf5b.png.webp";